import { useEffect, useState } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import MenuGrid from "@/components/MenuGrid";
import BookingForm from "@/components/BookingForm";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { Heart, MapPin, MessageCircle } from "lucide-react";

export default function HomePage() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch((e) => console.error("config load failed", e));
  }, []);

  return (
    <>
      <Header config={config} />
      <Hero config={config} />
      <MenuGrid content={config?.content} />
      <AboutStrip config={config} />
      <BookingForm config={config} />
      <Footer config={config} />
    </>
  );
}

function AboutStrip({ config }) {
  const c = config?.content || {};
  const items = [
    { icon: Heart, title: c.about_1_title || "Made with love", text: c.about_1_text || "Every treat is baked from scratch with premium ingredients." },
    { icon: MessageCircle, title: c.about_2_title || "Fully customized", text: c.about_2_text || "Flavors, colors, and design tailored to your vision." },
    { icon: MapPin, title: c.about_3_title || "Local delivery", text: c.about_3_text || "Direct to your event or setup for a dessert table." },
  ];
  return (
    <section id="about" className="bg-white border-y border-stone-100">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-8">
          {items.map(({ icon: Icon, title, text }, i) => (
            <div key={`about-${i}`} className="flex gap-4">
              <div className="h-11 w-11 shrink-0 rounded-full bg-sky-50 grid place-items-center">
                <Icon className="h-5 w-5 text-blue-800" />
              </div>
              <div>
                <h3 className="font-serif-display text-2xl text-stone-900 mb-1">{title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed">{text}</p>
              </div>
            </div>
          ))}
        </div>
        {config?.about && (
          <p className="mt-10 text-center max-w-2xl mx-auto text-stone-600 italic font-serif-display text-xl">
            {`"${config.about}"`}
          </p>
        )}
      </div>
    </section>
  );
}
